import { UseFormReturn } from "react-hook-form";

import TextEditor from "../../Global/Editors/TextEditor";
import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { bfv_J9 } from "../../../modules/Beräkningsmoduler/BFV_J9";
import { Button, Card, Row, Table } from "react-bootstrap";
import { IGlobalData } from "../../../types/globalData";
import { Chart, Series, ArgumentAxis, CommonSeriesSettings, Export, Legend, Margin, Title, Subtitle, Tooltip, Grid, CommonAxisSettings, ValueAxis, Size } from "devextreme-react/chart";
import Funktionskontroller from "./Funktionskontroller";
import DriftOptimeringar from "./DriftOptimeringar";
import BFLNote from "./BFLNote";
import { useBflHandler } from "../../../modules/Beräkningsmoduler/bflHandler";
import { BFLType } from "../../../types/DBTables";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import TemperaturInfo from "./TemperaturInfo";
import { Colors } from "../../../modules/Colors";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFV_J9 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const globaldataHandler = useGlobalData();
  const bflHandler = useBflHandler();

  const bimHandler = roundHandler.getBimHandler();

  const applyChanges = () => {
    //Update from From
    const formData: any = formHook.getValues();
    const bflResult = bflHandler.prepareData(module, BFLType.BFV_J9, formData);

    //module.bfs.BFV_J9 = bflResult;
    formHook.reset(bflResult);
  };

  const formData: any = formHook.getValues();
  if (formData && formData.data && formData.data.värmekurva && !formData.data.värmekurva.find((r: any) => r.brytpunktUtetempNy || r.brytpunktFramledningstempNy)) {
    let hasValues = false;

    for (let i = 0; i < formData.data.värmekurva.length; i++) {
      const row = formData.data.värmekurva[i];
      row.brytpunktUtetempNy = row.brytpunktUtetemp;
      row.brytpunktFramledningstempNy = row.brytpunktFramledningstemp;
      if (row.brytpunktUtetempNy || row.brytpunktFramledningstempNy) hasValues = true;
    }
    formData.data.parallellFörskjutningNy = formData.data.parallellFörskjutning;
    if (hasValues) {
      formHook.reset(formData);
    }
  }
  const applyParallellFörskjutning = (data: any) => {
    const värmekurva = data?.värmekurva;
    if (!värmekurva || värmekurva.length === 0) return [];
    const ret = [] as any[];
    for (var i = 0; i < värmekurva.length; i++) {
      var row = värmekurva[i];
      ret.push({
        brytpunktUtetemp: row.brytpunktUtetemp,
        brytpunktFramledningstemp: row.brytpunktFramledningstemp + (data.parallellFörskjutning || 0.0),
        brytpunktUtetempNy: row.brytpunktUtetempNy,
        brytpunktFramledningstempNy: row.brytpunktFramledningstempNy + (data.parallellFörskjutningNy || 0.0),
      });
    }

    return ret;
  };

  try {
    const bm = bfv_J9().getResult(module, bimHandler, roundHandler, globaldataHandler.data as IGlobalData, formData);

    const funktionsKontroller = bm.funktionsKontroller;
    const driftOptimeringar = bm.driftOptimeringar;
    const data = bm.data;

    const systemText = globaldataHandler.beräkningsflikarText.beskr_BFV_J9;

    return (
      <>
        <Card className="mb-3">
          <Card.Header>{systemText?.title}</Card.Header>
          <Card.Body>
            <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
            <TemperaturInfo tempInfo={data.temperaturInfo} stickprov={data.stickprov} />

            <Funktionskontroller bfName="BFV_J9" formHook={formHook} funktionsKontroller={funktionsKontroller} />
            <div style={{ overflow: "auto" }}>
              <Table striped bordered hover>
                <thead>
                  <tr style={{ backgroundColor: Colors.GrayLightest }} className="fs-5">
                    <th colSpan={2}>Befintlig kurva</th>
                    <th colSpan={2}>Ny kurva</th>
                  </tr>
                  <tr>
                    <th>Utetemperatur</th>
                    <th>Brytpunkt framledningstemperatur</th>
                    <th>Utetemperatur</th>
                    <th>Brytpunkt framledningstemperatur</th>
                  </tr>
                </thead>
                <tbody>
                  {bm.data.värmekurva.map((row: any, index: number) => (
                    <tr key={index}>
                      <td>
                        {row.brytpunktUtetemp}
                        <input defaultValue={row.brytpunktUtetemp} type="hidden" {...formHook.register("data.värmekurva." + index + ".brytpunktUtetemp", { value: row.brytpunktUtetemp })} />
                      </td>
                      <td>
                        {row.brytpunktFramledningstemp}
                        <input
                          defaultValue={row.brytpunktUtetemp}
                          type="hidden"
                          {...formHook.register("data.värmekurva." + index + ".brytpunktFramledningstemp", { value: row.brytpunktFramledningstemp })}
                        />
                      </td>
                      <td>
                        <input
                          defaultValue={row.brytpunktUtetempNy}
                          type="number"
                          step={1}
                          {...formHook.register("data.värmekurva." + index + ".brytpunktUtetempNy", { valueAsNumber: true })}
                          className="form-control"
                        />
                      </td>
                      <td>
                        <input
                          defaultValue={row.brytpunktFramledningstempNy}
                          type="number"
                          step={1}
                          {...formHook.register("data.värmekurva." + index + ".brytpunktFramledningstempNy", { valueAsNumber: true })}
                          className="form-control"
                        />
                      </td>
                    </tr>
                  ))}

                  <tr key={bm.data.värmekurva.length}>
                    <td>Parallellförskjutning</td>
                    <td>{bm.data.parallellFörskjutning}</td>
                    <td>Parallellförskjutning (ny)</td>
                    <td>
                      <input
                        defaultValue={bm.data.parallellFörskjutningNy}
                        type="number"
                        step={1}
                        {...formHook.register("data.parallellFörskjutningNy", { valueAsNumber: true })}
                        className="form-control"
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <div className="d-flex flex-row-reverse pe-3 mb-3">
              <Button className="" onClick={applyChanges} type="button">
                Applicera
              </Button>
            </div>

            <DriftOptimeringar bfName="BFV_J9" formHook={formHook} driftOptimeringar={driftOptimeringar} />

            {!bm.error && (
              <Chart className="mb-3" dataSource={applyParallellFörskjutning(bm.data)}>
                <Title text={"Värmekurva"}></Title>
                <CommonSeriesSettings argumentField="brytpunktUtetemp" type="line" />
                <ArgumentAxis title={"Utetemperatur"}></ArgumentAxis>
                <ValueAxis title={"Framledningstemperatur"}></ValueAxis>
                <Size height={400} width="100%" />
                <Series key="brytpunktFramledningstemp" argumentField={"brytpunktUtetemp"} valueField="brytpunktFramledningstemp" name="Befintlig" />
                <Series key="brytpunktFramledningstempNy" argumentField={"brytpunktUtetempNy"} valueField="brytpunktFramledningstempNy" name="Modifierad" />
              </Chart>
            )}

            <BFLNote formHook={formHook} />
            <ErrorInfo info={bm.error} />
            <DebugInfo info={bm.debug} />
          </Card.Body>
        </Card>
      </>
    );
  } catch (err: any) {
    return (
      <>
        <h3>Ett fel uppstod</h3>
        <h6>BFV J9: Funktionskontroll för Vattenburet sekundärvärmesystem. Regleravvikelse framledning.</h6>
        1. Kontroll medeltemperatur (Funktionskontroll).
        <br />
        2. Kontroll temperaturspann lokaler (Funktionskontroll)
        <br />
        3. Justering framledningskurva VS- system, genererar beräkningsresultat på sänkt eller höjd energianvändning. (Driftoptimering).
        <br />
        <div style={{ color: "red" }}> {err.message}</div>
      </>
    );
  }
};

export default BFV_J9;
